<ng-container *ngIf="footerType === 'discipline'">
  <ng-container *ngIf="(cardWidth <= 541) && blog.disciplines?.length; else defaultView">
    <h6 class="footer-text sparro-grey-800 margin-0">
      <a [href]="goToTopic(blog.disciplines[0].slug)" class="no-decor-hover cursor-pointer" *ngIf="blog.disciplines[0].slug">{{ blog.disciplines[0].name }} </a>
      <span (click)="goToDisciplineSearch(blog.disciplines[0])" *ngIf="!blog.disciplines[0].slug" class="cursor-pointer">{{ blog.disciplines[0].name }} </span>
    </h6>
  </ng-container>
  <ng-template #defaultView>
    <ng-container *ngFor="let discipline of blog.disciplines.slice(0,2); index as i">
      <h6 class="footer-text sparro-grey-800 margin-0">
        <a [href]="goToTopic(discipline.slug)" class="no-decor-hover cursor-pointer" *ngIf="discipline.slug">{{ discipline.name }} </a>
        <span (click)="goToDisciplineSearch(discipline)" *ngIf="!discipline.slug" class="cursor-pointer">{{ discipline.name }} </span>
        <span *ngIf="i < (blog.disciplines.length - 1)">.&nbsp;</span>
      </h6>
    </ng-container>
  </ng-template>
</ng-container>

<ng-container *ngIf="footerType === 'timestamp'">
  <h6 class="blog-timestamp margin-0">Last edited: {{ blog.updated_at | timesince }} ago</h6>
</ng-container>

<ng-container *ngIf="footerType === 'score'">
  <div fxLayout="row" fxLayoutAlign="start center" class="height-100 padding-bottom-1">
    <ng-container *ngIf="blog.evaluation_score; else noEvalScore">
      <h6 class="margin-0 sparro-yellow-800" style="font-size:16px;" [ngClass]="{'sparro-green-600': blog.evaluated }">
        Score: {{ blog.evaluation_score }}
      </h6>
    </ng-container>
    <ng-template #noEvalScore>
      <h6 class="sparro-orange-800 margin-0" style="font-size:16px;">
        Score: N/E
      </h6>
    </ng-template>
  </div>
</ng-container>

<!-- <ng-container *ngIf="footerType === 'likes'">
  <div fxLayout="row" class="likes-footer">
    <uni-like-button
      style="height: inherit;"
      [item]="blog"
      [source]="source"
      [showCount]="true">
    </uni-like-button>
  </div>
</ng-container> -->

<ng-container *ngIf="footerType === 'none'">
</ng-container>
